import {buildAuthService} from '@eitje/store'

export const authService = buildAuthService({
	scope: 'admin',
})
